import React from 'react';
import AdminLayout from './AdminLayout';
import NotificationOversightSettings from '../../components/admin/NotificationOversightSettings';

export default function AdminNotificationsPage() {
    return (
        <AdminLayout title="Notifications" description="Choose which events also notify admins and managers">
            <NotificationOversightSettings />
        </AdminLayout>
    );
}
